// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1d33a","rightAdornment":"Header_rightAdornment__3-Iu-"};